export const domainIgnoreList = [
  'gmail.com',
  'outlook.com',
  'hotmail.com',
  'live.com',
  'msn.com',
  'zoomcrc.com',
  'yahoo.com',
  'aol.com',
  'icloud.com',
  'protonmail.com',
  'yandex.com',
  'zoho.com',
  'mail.com',
  'gmx.com',
  'rose.greenhouse.io',
  'resource.calendar.google.com',
];
